"use client"
import { CssBaseline } from "@mui/material"
import { AppRouterCacheProvider } from "@mui/material-nextjs/v14-appRouter"
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from "@mui/material/styles"
import React from "react"
import rtlPlugin from "stylis-plugin-rtl"
import { theme } from "./theme"

export const ltrTheme = createTheme({ ...theme, direction: "ltr" })
export const rtlTheme = createTheme({ ...theme, direction: "rtl" })

const ThemeProviders = ({
  children,
  locale = "he",
}: {
  children: React.ReactNode
  locale: string
}) => {
  const [isRtl, setIsRtl] = React.useState(locale === "he" ? true : false)

  React.useLayoutEffect(() => {
    document?.body.setAttribute("dir", isRtl ? "rtl" : "ltr")
  }, [isRtl])
  React.useLayoutEffect(() => {
    setIsRtl(locale === "he" ? true : false)
  }, [locale])

  const options = {
    key: isRtl ? "muirtl" : "muiltr",
    stylisPlugins: isRtl ? [rtlPlugin] : undefined,
  }

  const currentTheme = isRtl ? rtlTheme : ltrTheme

  return (
    <AppRouterCacheProvider options={options}>
      <MuiThemeProvider theme={currentTheme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </AppRouterCacheProvider>
  )
}

export default ThemeProviders
